import { render, staticRenderFns } from "./AssignParticipantCampusWeek.vue?vue&type=template&id=f8fc1604&scoped=true"
import script from "./AssignParticipantCampusWeek.vue?vue&type=script&lang=js"
export * from "./AssignParticipantCampusWeek.vue?vue&type=script&lang=js"
import style0 from "./AssignParticipantCampusWeek.vue?vue&type=style&index=0&id=f8fc1604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fc1604",
  null
  
)

export default component.exports